import { Button, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IconWarningTriangle } from './icons'

export const ProcountorVersionWarningModal = ({ show, onHide, onConfirm }) => {
	const { t } = useTranslation()

	return (
		<Modal show={show} onHide={onHide} centered backdrop="static" size="lg">
			<Modal.Header
				closeButton
				className="px-4 border-0 integration-modal-header"
				style={{ backgroundColor: '#C2660A' }}
			>
				<Modal.Title className="d-flex align-items-center gap-3 fw-bold" style={{ color: '#FFFFFF' }}>
					<IconWarningTriangle size={24} style={{ color: '#FFFFFF' }} />
					<span style={{ color: '#FFFFFF' }}>{t('ProcountorVersionWarningTitle', 'Procountor-päivitys')}</span>
				</Modal.Title>
			</Modal.Header>

			<Modal.Body className="p-4">
				<p className="mb-4">
					{t(
						'ProcountorDataChangedInProcountor',
						'Henkilön tietoja on muokattu Procountorissa tämän sivun avaamisen jälkeen. Tallentaminen ylikirjoittaa Procountorissa tehdyt muutokset.',
					)}
				</p>

				<p className="fw-bold mt-3 text-center">
					{t('DoYouWantToSaveAnyway', 'Haluatko tallentaa HR-tiedot ilman integraatioiden synkronointia?')}
				</p>
			</Modal.Body>

			<Modal.Footer className="border-0 pb-4">
				<Button className="btn-return" onClick={onHide}>
					{t('BackToForm', 'Palaa muokkaamaan')}
				</Button>

				<Button variant="primary" onClick={onConfirm}>
					{t('SaveAnyway', 'Tallenna silti')}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
